import React from 'react';
import { Link } from 'react-router-dom';
import useBlogPosts from '../hooks/useBlogPosts';

const BlogSection = () => {
    const { posts, loading } = useBlogPosts();

    return (
        <section id="blog" className="section-divider py-24" style={{ background: 'rgba(7,8,15,0.82)' }}>
            <div className="container max-w-5xl mx-auto px-6 lg:px-8">

                <div className="mb-12">
                    <span className="text-orange-400 text-xs tracking-widest uppercase font-medium">Writing</span>
                    <h2 className="text-4xl font-bold text-white mt-3">Blog</h2>
                </div>

                {loading ? (
                    <div className="flex flex-col gap-4">
                        {[1, 2].map((n) => (
                            <div key={n} className="glass-card p-7 animate-pulse">
                                <div className="h-3 rounded-full w-32 mb-4" style={{ background: 'rgba(255,255,255,0.07)' }} />
                                <div className="h-5 rounded-full w-3/4 mb-3" style={{ background: 'rgba(255,255,255,0.07)' }} />
                                <div className="h-4 rounded-full w-full mb-2" style={{ background: 'rgba(255,255,255,0.05)' }} />
                                <div className="h-4 rounded-full w-2/3" style={{ background: 'rgba(255,255,255,0.05)' }} />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col gap-4">
                        {posts.map((post) => (
                            <Link
                                key={post.id}
                                to={`/blog/${post.id}`}
                                className="glass-card group block p-7 cursor-pointer"
                            >
                                <div className="flex items-center justify-between gap-4">
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-3 mb-3">
                                            <span className="text-xs text-orange-400 tracking-widest uppercase font-medium">
                                                {post.category}
                                            </span>
                                            <span style={{ color: 'rgba(255,255,255,0.2)' }}>&middot;</span>
                                            <span className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
                                                {post.date}
                                            </span>
                                            <span style={{ color: 'rgba(255,255,255,0.2)' }}>&middot;</span>
                                            <span className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
                                                {post.readTime}
                                            </span>
                                        </div>
                                        <h3
                                            className="font-semibold text-lg mb-2 leading-snug transition-colors duration-200 group-hover:text-orange-400"
                                            style={{ color: 'rgba(255,255,255,0.9)' }}
                                        >
                                            {post.title}
                                        </h3>
                                        <p
                                            className="text-sm leading-relaxed line-clamp-2"
                                            style={{ color: 'rgba(255,255,255,0.44)' }}
                                        >
                                            {post.excerpt}
                                        </p>
                                    </div>
                                    <div
                                        className="flex-shrink-0 transition-colors duration-200 group-hover:text-orange-400"
                                        style={{ color: 'rgba(255,255,255,0.25)' }}
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5l7 7-7 7" />
                                        </svg>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}

            </div>
        </section>
    );
};

export default BlogSection;
